import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-default-boolean',
  templateUrl: './boolean.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooleanComponent {
  @Input() customClass = '';
  @Input() set data(value) {
    this.isActive = value === true || value === '1' || value === 1;
  }

  public isActive: boolean;
}
